import { User } from 'types/userInfo';
import L from 'leaflet';
import assetLocationIcon from '../icons/asset-location-icon.svg';
import staleIcon from '../icons/stale-asset.svg';
import { differenceInSeconds } from 'date-fns';
import { Asset } from 'types/asset';

export function getIconFromEstimateFreshness(
  estimate: Asset,
  freshPeriodThresholdSeconds: number,
) {
  // function to return correct icon based on estimate age, from config defined values.
  const timeNow = new Date();
  const timeDifferenceInSeconds = differenceInSeconds(
    timeNow,
    new Date(estimate.last_location_update_timestamp),
  );
  const estimateIsFresh = timeDifferenceInSeconds <= freshPeriodThresholdSeconds;
  return estimateIsFresh ? assetLocationIcon : staleIcon;
}


export function getCoordsFromAssets(assets: Asset[]) {
  return assets.map((asset) => ([
    asset.location.coordinates.latitude,
    asset.location.coordinates.longitude,
  ]))
}

export function getCoordsFromUsers(users: User[]) {
  return users.map((user) => ([
    user.location.coordinates.latitude,
    user.location.coordinates.longitude,
  ]))
}

export function getCombinedLevelAssetUserBounds(
  assets: Asset[],
  users: User[],
  levels: any,
) {
  // function to return bounds for map that includes all levels and markers.
  // To account for outside marked building assets too
  const bounds = L.geoJSON(levels).getBounds();
  const assetCoords: any = getCoordsFromAssets(assets);
  const userCoords: any = getCoordsFromUsers(users);

  bounds.extend(assetCoords);
  bounds.extend(userCoords);

  return bounds;
}
